import { createContext, PropsWithChildren, ReactElement, useContext, useMemo } from 'react'

import {
  useInvoiceSettingsModalsAutomaticPaymentReminders,
  UseInvoiceSettingsModalsAutomaticPaymentRemindersResult,
} from '../hooks/useInvoiceSettingsModalsAutomaticPaymentReminders'
import {
  useInvoiceSettingsModalsLegalMentions,
  UseInvoiceSettingsModalsLegalMentionsResult,
} from '../hooks/useInvoiceSettingsModalsLegalMentions'
import {
  useInvoiceSettingsModalsVatExemptionMention,
  UseInvoiceSettingsModalsVatExemptionMentionResult,
} from '../hooks/useInvoiceSettingsModalsVatExemptionMention'

interface ContextState {
  automaticPaymentRemindersModal: UseInvoiceSettingsModalsAutomaticPaymentRemindersResult
  legalMentionsModal: UseInvoiceSettingsModalsLegalMentionsResult
  vatExemptionMentionModal: UseInvoiceSettingsModalsVatExemptionMentionResult
}

const InvoiceSettingsModalsContext = createContext<ContextState | undefined>(undefined)

export const InvoiceSettingsModalsContextProvider = ({ children }: PropsWithChildren): ReactElement => {
  const automaticPaymentRemindersModal = useInvoiceSettingsModalsAutomaticPaymentReminders()
  const legalMentionsModal = useInvoiceSettingsModalsLegalMentions()
  const vatExemptionMentionModal = useInvoiceSettingsModalsVatExemptionMention()

  const contextValue = useMemo(
    () => ({
      automaticPaymentRemindersModal,
      legalMentionsModal,
      vatExemptionMentionModal,
    }),
    [automaticPaymentRemindersModal, legalMentionsModal, vatExemptionMentionModal],
  )

  return <InvoiceSettingsModalsContext.Provider value={contextValue}>{children}</InvoiceSettingsModalsContext.Provider>
}

export const useInvoiceSettingsModals = () => {
  const context = useContext(InvoiceSettingsModalsContext)

  if (!context) {
    throw new Error('InvoiceSettingsModalsContextProvider is missing in the module!')
  }

  return context
}
